// @ts-nocheck
import { Component } from 'react';
import { ApplyPluginsType } from 'umi';
import dva from 'dva';
// @ts-ignore
import createLoading from '/root/workspace/ccrc-health-management_Ligp/node_modules/dva-loading/dist/index.esm.js';
import { plugin, history } from '../core/umiExports';
import ModelCreateHealthReport0 from '/root/workspace/ccrc-health-management_Ligp/src/models/createHealthReport.tsx';
import ModelInquiry1 from '/root/workspace/ccrc-health-management_Ligp/src/models/inquiry.ts';
import ModelLocationState2 from '/root/workspace/ccrc-health-management_Ligp/src/models/locationState.ts';
import ModelMessage3 from '/root/workspace/ccrc-health-management_Ligp/src/models/message.ts';
import ModelCustomization4 from '/root/workspace/ccrc-health-management_Ligp/src/pages/TenantSettings/CustomizePage/models/customization.ts';
import ModelHomepage5 from '/root/workspace/ccrc-health-management_Ligp/src/pages/TenantSettings/HomepageDecoration/models/homepage.ts';
import dvaImmer, { enableES5, enableAllPlugins } from '/root/workspace/ccrc-health-management_Ligp/node_modules/dva-immer/dist/index.js';

let app:any = null;

export function _onCreate(options = {}) {
  const runtimeDva = plugin.applyPlugins({
    key: 'dva',
    type: ApplyPluginsType.modify,
    initialValue: {},
  });
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    // @ts-ignore
    ...(typeof window !== 'undefined' && window.g_useSSR ? { initialState: window.g_initialProps } : {}),
    ...(options || {}),
  });
  
  app.use(createLoading());
  app.use(dvaImmer());
  (runtimeDva.plugins || []).forEach((plugin:any) => {
    app.use(plugin);
  });
  app.model({ namespace: 'createHealthReport', ...ModelCreateHealthReport0 });
app.model({ namespace: 'inquiry', ...ModelInquiry1 });
app.model({ namespace: 'locationState', ...ModelLocationState2 });
app.model({ namespace: 'message', ...ModelMessage3 });
app.model({ namespace: 'customization', ...ModelCustomization4 });
app.model({ namespace: 'homepage', ...ModelHomepage5 });
  return app;
}

export function getApp() {
  return app;
}

/**
 * whether browser env
 * 
 * @returns boolean
 */
function isBrowser(): boolean {
  return typeof window !== 'undefined' &&
  typeof window.document !== 'undefined' &&
  typeof window.document.createElement !== 'undefined'
}

export class _DvaContainer extends Component {
  constructor(props: any) {
    super(props);
    // run only in client, avoid override server _onCreate()
    if (isBrowser()) {
      _onCreate()
    }
  }

  componentWillUnmount() {
    let app = getApp();
    app._models.forEach((model:any) => {
      app.unmodel(model.namespace);
    });
    app._models = [];
    try {
      // 释放 app，for gc
      // immer 场景 app 是 read-only 的，这里 try catch 一下
      app = null;
    } catch(e) {
      console.error(e);
    }
  }

  render() {
    let app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
